import { Box, Button, Dialog, DialogContent, DialogTitle, FormControlLabel, Input, MenuItem, Radio, RadioGroup, Select, Stack, TextField, Typography } from "@mui/material"
import { COLOR } from "../../../utils/colors"
import { CalendarContentProps } from "./Calendar.types"
import { useEffect, useState } from "react"
import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import { useRobots } from "../../../hooks/robot"
import { useLocationPoints } from "../../../hooks/location"
import { OptionsObject, useSnackbar } from "notistack"
import { useCreateScheduledCleaningJob, useCreateScheduledJob, useEditScheduledCleaningJob, useEditScheduledJob, useEditThisAndFollowingScheduledCleaningJob, useEditThisAndFollowingScheduledJob, useEditThisScheduledCleaningJob, useEditThisScheduledJob } from "../../../hooks/scheduled_jobs"
import { customLog } from "../../../utils/utils"
import MultiSelection, { ValueType } from "./MultiSelection"
import { cleaningOptions } from "../../dashboard/components/CleaningDialog"
import { getProfile } from "../../../utils/api"
import { getCleaningTypeLabel, useListAvailableZones } from "../../../hooks/cleaning"
import { useListMap } from "../../../hooks/map"
import { ListScheduleCleaningProjection, StoreScheduleJobProps } from "../../../hooks/scheduled_jobs/index.type"
import { repeatOptions } from "../_function/common"
import { DashboardMode } from "../../../utils/enums/Dashboard"
import { useDashboardMode } from "../../../hooks/appMode"

export const taskTypes = [
  {
    name: 'Delivery',
    value: 'delivery_job',
    mode: [DashboardMode.DELIVERY]
  }, {
    name: 'Charging',
    value: 'charging_job',
    mode: [DashboardMode.DELIVERY]
  }, {
    name: 'Go To',
    value: 'go_to_job',
    mode: [DashboardMode.DELIVERY]
  }, {
    name: "Cleaning",
    value: "cleaning_job",
    mode: [DashboardMode.CLEANING]
  }
]

const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thusday', 'friday', 'saturday'];

// const locations = [
//   {
//     name: "Point A",
//   },
//   {
//     name: "Point B",
//   },
//   {
//     name: "Point C",
//   },
//   {
//     name: "Point D",
//   }
// ]

export default function JobForm({
  form,
  isEdit,
  onEdit,
  onCancelEdit,
  onCreate,
  onCancelCreate,
  selectedDate
}: {
  form?: CalendarContentProps | ListScheduleCleaningProjection
  isEdit?: boolean,
  onEdit?: (data?: CalendarContentProps | ListScheduleCleaningProjection) => void
  onCancelEdit?: () => void,
  onCreate?: (data?: CalendarContentProps | ListScheduleCleaningProjection) => void,
  onCancelCreate?: () => void,
  selectedDate?: Date
}) {
  const { data: dataRobot, isLoading: isLoadingRobot } = useRobots();
  const robots = dataRobot?.data || [];

  const { dashboardMode } = useDashboardMode()

  const [content, setContent] = useState<CalendarContentProps | ListScheduleCleaningProjection>()
  // Dummy Form Value

  // Form
  const [selectedRepeat, setSelectedRepeat] = useState('do_not_repeat')
  const [selectedDays, setSelectedDays] = useState<string[]>([])
  const [taskName, setTaskName] = useState('');
  const [taskDescription, setTaskDescription] = useState('');
  const [taskType, setTaskType] = useState('')
  const [selectedRobot, setSelectedRobot] = useState('');
  const [senderLocation, setSenderLocation] = useState('');
  const [recipientLocation, setRecipientLocation] = useState('');
  const [selectedTime, setSelectedTime] = useState<Date | undefined>(new Date());
  const [endRepeatType, setEndRepeatType] = useState<string>('none');
  const [endByOccurence, setEndByOccurence] = useState('1');
  const [endByDate, setEndByDate] = useState<Date | undefined>(new Date());
  const [openConfirmUpdate, setOpenConfirmUpdate] = useState(false)
  const [cleaningType, setCleaningType] = useState<string>('')
  const [editType, setEditType] = useState('this_event')
  const organisation_id = getProfile()?.organisation
  const { data, refetch: refetchZone } = useListAvailableZones({
    organisation_id,
  });
  // const zoneOptions = mockZoneOptions;
  const zoneOptions = data?.data || []

  const { data: dataListMaps } = useListMap({
    page_size: 100
  })

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const resetForm = () => {
    setSelectedRepeat('do_not_repeat')
    setSelectedDays([]);
    setTaskName('')
    setTaskDescription('')
    setTaskType('')
    setSelectedRobot('')
    setSenderLocation('')
    setRecipientLocation('')
    setSelectedTime(new Date())
    setEndRepeatType('none')
    setEndByOccurence('1')
    setEndByDate(new Date())

    setCleaningZones([''])
    setCleaningType('')

    setEditType('')
    setOpenConfirmUpdate(false)
  }
  const { trigger: submitScheduleJob, isLoading: isMutatingScheduled } = useCreateScheduledJob({
    onSuccess: () => {
      resetForm()
      onCreate?.()
    }
  })

  const { trigger: submitEditThisEventCleaning, isLoading: isLoadingEditThisEvent } = useEditThisScheduledCleaningJob({
    onSuccess: () => {
      resetForm()
      onEdit?.()
    },
    organisation_id: organisation_id
  })

  const { trigger: submitEditThisEvent, isLoading: isLoadingEditThisEventDelivery } = useEditThisScheduledJob({
    onSuccess: () => {
      resetForm()
      onEdit?.()
    },
    organisation_id: organisation_id
  })

  const { trigger: submitScheduleCleaningJob, isLoading: isMutatingScheduledCleaning } = useCreateScheduledCleaningJob({
    onSuccess: () => {
      resetForm()
      onCreate?.()
    },
    organisation_id: organisation_id
  })


  const { trigger: submitEditThisAndFollowingCleaning } = useEditThisAndFollowingScheduledCleaningJob({
    onSuccess: () => {
      resetForm()
      onEdit?.()
    },
    organisation_id: organisation_id,
    task_id: form ? ((form as any).key_id || form?.id.toString()) : ''
  })

  const { trigger: submitEditThisAndFollowing } = useEditThisAndFollowingScheduledJob({
    onSuccess: () => {
      resetForm()
      onEdit?.()
    },
    organisation_id: organisation_id,
    task_id: form ? ((form as any).key_id || form?.id.toString()) : ''
  })

  const { trigger: submitEditAllCleaning } = useEditScheduledCleaningJob({
    onSuccess: () => {
      resetForm()
      onEdit?.()
    },
    organisation_id: organisation_id,
    task_id: form ? ((form as any).key_id || form?.id.toString()) : ''
  })

  const { trigger: submitEditAll } = useEditScheduledJob({
    onSuccess: () => {
      resetForm()
      onEdit?.()
    },
    organisation_id: organisation_id,
    task_id: form ? ((form as any).key_id || form?.id.toString()) : ''
  })

  const { data: dataLocation, isLoading: isLoadingLocation, refetch: refetchLocation } = useLocationPoints(taskType === 'charging_job' ? 'charging_point' : 'waypoint');
  const locations = dataLocation?.data || [];

  const isCleaningJob = ['cleaning_job'].includes(taskType)
  const [cleaningZones, setCleaningZones] = useState<ValueType[]>([''])

  useEffect(() => {
    if (!selectedTime) {
      return
    }
    if (selectedRepeat && !['weekly', 'biweekly'].includes(selectedRepeat)) {
      setSelectedDays([])
      return
    }
    const dayNum = selectedTime?.getDay();
    const dayName = weekdays[dayNum];

    if (!selectedDays.includes(dayName)) {
      const tmpDays = selectedDays.length <= 1 ? [] : [...selectedDays]
      tmpDays.push(dayName)
      setSelectedDays(tmpDays)
    }
  }, [selectedRepeat, selectedTime])

  useEffect(() => {
    if (!taskType || !dataLocation) { return }
    customLog(taskType);

    refetchLocation()
  }, [taskType])

  const showErrorToast = (message: string, option: OptionsObject = {}) => {
    enqueueSnackbar(message, {
      variant: 'error',
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'top'
      },
      style: { fontFamily: "Poppins" },
      ...option
    })
    return
  }

  const subDayName = (days: string[]) => {
    return days.map((day) => {
      return day.charAt(0).toUpperCase() + day.substring(1, 3).toLowerCase()
    })
  }

  const onSubmitCreate = () => {
    if (isMutatingScheduled || isMutatingScheduledCleaning) {
      return
    }
    if (!taskType) {
      showErrorToast("Please Select Task Type")
      return
    }
    if (!selectedRobot && !isCleaningJob) {
      showErrorToast("Plase Select Robot")
      return
    }
    if (['delivery_job'].includes(taskType) && !senderLocation) {
      showErrorToast("Please Select Pickup Location")
      return
    }

    if (!recipientLocation && !isCleaningJob) {
      showErrorToast(['delivery_job'].includes(taskType) ? "Please Select Delivery Location" : "Please Select the Location")
      return
    }

    if (['weekly', 'biweekly'].includes(selectedRepeat) && selectedDays.length === 0) {
      showErrorToast("Please Select Repeat Day")
      return
    }

    if (!selectedTime) {
      showErrorToast("Please Choose the Time")
      return
    }

    if (isCleaningJob) {
      refetchZone()
      if (!cleaningType) {
        showErrorToast("Please Select Cleaning Mode")
        return
      }
      if (cleaningZones.filter((item) => item.toString().length > 0).length <= 0) {
        showErrorToast("Please Select Zone")
        return
      }
      if (zoneErrors.length > 0) {
        zoneErrors.forEach(element => {
          showErrorToast(element)
        });
        return
      }
      const cleaningForm = {
        recurring_type: selectedRepeat,
        title: taskName,
        description: taskDescription,
        days: ['weekly', 'biweekly'].includes(selectedRepeat) ? subDayName(selectedDays) : [],
        areas: cleaningZones.map((item) => item.toString()),
        cleaning_type: cleaningType,
        occurrence: endRepeatType === 'by_occurrence' ? parseInt(endByOccurence) : undefined,
        timestamp: parseInt((selectedTime.getTime() / 1000) + ''),
        timestamp_end: endRepeatType === 'by_date' && endByDate ? parseInt((endByDate.getTime() / 1000) + '') : undefined
      }

      submitScheduleCleaningJob(cleaningForm)
      return
    }

    const form = {
      title: taskName,
      description: taskDescription,
      job_type: taskType,
      required_compartment: 1,
      robot_id: selectedRobot === 'near' ? "" : selectedRobot,
      sender_location: senderLocation,
      sender_name: 'John',
      recipient_name: 'Kelvin',
      recipient_location: recipientLocation,
      timestamp: parseInt((selectedTime.getTime() / 1000) + ''),
      recurring_type: selectedRepeat,
      days: ['weekly', 'biweekly'].includes(selectedRepeat) ? subDayName(selectedDays) : [],
      occurrence: endRepeatType === 'by_occurrence' ? parseInt(endByOccurence) : undefined,
      timestamp_end: endRepeatType === 'by_date' && endByDate ? parseInt((endByDate.getTime() / 1000) + '') : undefined
    }
    submitScheduleJob(form)
  }

  useEffect(() => {
    if (!form) {
      return
    }
    setContent(form)
  }, [form])

  const toggleDay = (day: string) => {
    const tmpRes = [...selectedDays];
    // Already Exist
    if (selectedDays.includes(day)) {
      // Then Remove it
      const findIndex = tmpRes.findIndex((item) => item === day);

      if (findIndex < 0) {
        return
      }

      tmpRes.splice(findIndex, 1);
      setSelectedDays(tmpRes)
      return
    }

    tmpRes.push(day)
    setSelectedDays(tmpRes)
  }


  const getSelectedRepeatLabel = () => {
    switch (selectedRepeat) {
      case 'daily':
        return 'Day';

      case 'weekly':
        return 'Week';

      case 'monthly':
        return 'Month'
      default:
        return selectedRepeat
        break;

    }
  }


  const isShowPickup = ['delivery_job'].includes(taskType)

  const disabledEndRepeat = false

  const listMaps = dataListMaps?.data || []

  const findMap = (map_uuid?: string) => {
    if (!map_uuid) {
      return undefined
    }
    return listMaps.find((data) => data.map_uuid === map_uuid)
  }

  useEffect(() => {
    if (!isEdit || !form) {
      return
    }

    setTaskName(form.title || '')
    setTaskDescription(form.description || '')
    setTaskType((form as any).job_type || 'delivery_job')
    if ((form as any).job_type === 'cleaning_job') {
      const data = form as ListScheduleCleaningProjection
      setCleaningType(data.cleaning_type)
      setSelectedTime(dayjs.unix(data.start_timestamp).toDate())
      setSelectedRepeat(data.recurring_type)



      if (data.days && data.days.length > 0) {
        const filterWeekday = data.days.map((item) => weekdays.find((wDay) => wDay.toLowerCase().includes(item.toLowerCase()))) || []
        if (filterWeekday.length > 0) {
          setSelectedDays(filterWeekday as string[])
        }
      }

      setCleaningZones(data.zone.map((item) => item.zone_uuid) || [''])

      // Handle Repeat
      if (data.occurrence > 0) {
        setEndRepeatType('by_occurrence')
        setEndByOccurence(data.occurrence.toString())
      } else if (!!data.end_timestamp && data.end_timestamp > 0) {
        setEndRepeatType('by_date')
        setEndByDate(dayjs(data.end_timestamp).toDate())
      } else {
        setEndRepeatType('none')
      }
    }
    if ((form as any).job_type === 'delivery_job') {
      const data = form as CalendarContentProps

      setSelectedRobot(data.robot_id || 'near')
      setRecipientLocation(data.recipient_location)
      setSenderLocation(data.sender_location)
      setSelectedTime(dayjs.unix(data.timestamp).toDate())

      if (data.occurrence && data.occurrence > 0) {
        setEndRepeatType('by_occurrence')
        setEndByOccurence(data.occurrence.toString())
      } else if (!!data.timestamp_end && data.timestamp_end > 0) {
        setEndRepeatType('by_date')
        setEndByDate(dayjs(data.timestamp_end).toDate())
      } else {
        setEndRepeatType('none')
      }
    }
  }, [isEdit, form])

  const onCancelConfirmEdit = () => {
    onCancelEdit?.()
  }

  const onSaveConfirmEdit = () => {
    if (!editType) {
      return
    }

    if (!taskType) {
      showErrorToast("Please Select Task Type")
      return
    }
    if (!selectedRobot && !isCleaningJob) {
      showErrorToast("Plase Select Robot")
      return
    }
    if (['delivery_job'].includes(taskType) && !senderLocation) {
      showErrorToast("Please Select Pickup Location")
      return
    }

    if (!recipientLocation && !isCleaningJob) {
      showErrorToast(['delivery_job'].includes(taskType) ? "Please Select Delivery Location" : "Please Select the Location")
      return
    }

    if (['weekly', 'biweekly'].includes(selectedRepeat) && selectedDays.length === 0) {
      showErrorToast("Please Repeat Day")
      return
    }

    if (!selectedTime) {
      showErrorToast("Please Choose the Time")
      return
    }

    if (isCleaningJob) {
      if (!cleaningType) {
        showErrorToast("Please Select Cleaning Mode")
        return
      }
      if (cleaningZones.filter((item) => item.toString().length > 0).length <= 0) {
        showErrorToast("Please Select Zone")
        return
      }
      if (zoneErrors.length > 0) {
        zoneErrors.forEach(element => {
          showErrorToast(element)
        });
        return
      }
      const cleaningForm = {
        job_id: parseInt((content as any).key_id),
        recurring_type: selectedRepeat,
        title: taskName,
        description: taskDescription,
        days: ['weekly', 'biweekly'].includes(selectedRepeat) ? subDayName(selectedDays) : [],
        areas: cleaningZones.map((item) => item.toString()),
        cleaning_type: cleaningType,
        occurrence: endRepeatType === 'by_occurrence' ? parseInt(endByOccurence) : undefined,
        timestamp: parseInt((selectedTime.getTime() / 1000) + ''),
        timestamp_end: endRepeatType === 'by_date' && endByDate && selectedRepeat !== "do_not_repeat" ? parseInt((endByDate.getTime() / 1000) + '') : undefined
      }

      switch (editType) {
        case 'this_event':
          submitEditThisEventCleaning({
            ...cleaningForm,
            occurrence: 1
          })
          break;

        case 'this_and_following':
          submitEditThisAndFollowingCleaning({
            ...cleaningForm,
          }, (form as ListScheduleCleaningProjection).start_timestamp)
          break;

        case 'all':
          submitEditAllCleaning(cleaningForm)
          break;

        default:
          break;
      }
    } else {
      const form: StoreScheduleJobProps & { job_id: number } = {
        job_id: parseInt((content as any).key_id),
        title: taskName,
        description: taskDescription,
        job_type: taskType,
        required_compartment: 1,
        robot_id: selectedRobot === 'near' ? "" : selectedRobot,
        sender_location: senderLocation,
        sender_name: 'John',
        recipient_name: 'Kelvin',
        recipient_location: recipientLocation,
        timestamp: parseInt((selectedTime.getTime() / 1000) + ''),
        recurring_type: selectedRepeat,
        days: ['weekly', 'biweekly'].includes(selectedRepeat) ? subDayName(selectedDays) : [],
        occurrence: endRepeatType === 'by_occurrence' ? parseInt(endByOccurence) : undefined,
        timestamp_end: endRepeatType === 'by_date' && endByDate ? parseInt((endByDate.getTime() / 1000) + '') : -1,
      }
      switch (editType) {
        case 'this_event':
          submitEditThisEvent({
            ...form,
            occurrence: 1
          })
          break;

        case 'this_and_following':
          submitEditThisAndFollowing({
            ...form,
          }, (form as StoreScheduleJobProps).timestamp)
          break;

        case 'all':
          submitEditAll(form)
          break;

        default:
          break;
      }
    }
  }

  const zoneValidation = () => {
    if (zoneOptions.length === 0 || !isCleaningJob || cleaningZones.length === 0 || !cleaningType) {
      return []
    }

    const filterNotSupport = cleaningZones.filter((item) => {
      if (!item) {
        return false
      }

      const findZone = zoneOptions.find((zone) => zone.uuid === item)
      if (!findZone) {
        return true
      }

      return !findZone.jobs.find((job) => job.cleaning_type === cleaningType)
    })

    if (filterNotSupport.length === 0) {
      return []
    }


    return filterNotSupport.map(
      (item) =>
        [zoneOptions.find((zone) => zone.uuid === item)?.area_name,
          'not support for',
        getCleaningTypeLabel(cleaningType)].join(' ')
    )
  }
  const zoneErrors = zoneValidation()

  const filteredTaskType = taskTypes.filter((type) => type.mode.includes(dashboardMode))

  useEffect(() => {
    if (!taskType && filteredTaskType.length === 1) {
      setTaskType(filteredTaskType[0].value)
    }
  }, [filteredTaskType])

  useEffect(() => {
    if(!selectedDate || isEdit) {
      return
    }
    setSelectedTime(selectedDate)
  }, [selectedDate])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div >
          <Typography
            fontSize={12}
            color={COLOR.gray[400]}
          >
            Task Name (Optional)
          </Typography>
          <TextField
            sx={{
              width: '100%'
            }}
            size="small"
            defaultValue={content?.title || content?.id}
            maxRows={4}
            value={taskName}
            onChange={(e) => setTaskName(e.target.value)}
            placeholder="Task Name (Optional)"
          />
        </div>
        <div >
          <Typography
            fontSize={12}
            color={COLOR.gray[400]}
          >
            Description (Optional)
          </Typography>
          <TextField
            sx={{
              width: '100%'
            }}
            size="small"
            defaultValue={content?.description}
            multiline
            minRows={2}
            maxRows={4}
            value={taskDescription}
            onChange={(e) => setTaskDescription(e.target.value)}
            placeholder="Task Description (Optional)"
          />
        </div>
        <div >
          <Typography
            fontSize={12}
            color={COLOR.gray[400]}
          >
            Task Type
          </Typography>
          <Select
            sx={{
              width: '100%'
            }}
            size="small"
            defaultValue={(content as CalendarContentProps)?.job_type || filteredTaskType[0].value}
            value={taskType}
            disabled={isEdit || filteredTaskType.length === 1}
            onChange={(e) => {
              setTaskType(e.target.value)
              if (disabledEndRepeat) {
                setEndRepeatType('none')
              }
            }}
            placeholder="Task Type"
          >
            {filteredTaskType.map((option, index) => (
              <MenuItem key={index} value={option.value}>{option.name}</MenuItem>
            ))}
          </Select>
        </div>
        {!!taskType && !isCleaningJob && (
          <div>
            <Typography
              fontSize={12}
              color={COLOR.gray[400]}
            >
              Robot
            </Typography>
            <div style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Select
                sx={{
                  width: '100%'
                }}
                size="small"
                defaultValue={''}
                value={selectedRobot}
                onChange={(e) => setSelectedRobot(e.target.value)}
                placeholder="Select Robot"
              >
                {
                  isLoadingRobot && (
                    <MenuItem>Loading...</MenuItem>
                  )
                }
                {!isLoadingRobot && (
                  <MenuItem value="near">Any Robot</MenuItem>
                )}
                {robots.map((option, index) => (
                  <MenuItem key={index} value={option.robot_mac}>{option.robot_name}</MenuItem>
                ))}
              </Select>
            </div>
          </div>
        )}
        {isShowPickup && !isCleaningJob && (
          <div>
            <Typography
              fontSize={12}
              color={COLOR.gray[400]}
            >
              Pickup Location
            </Typography>
            <div style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Select
                sx={{
                  width: '100%'
                }}
                size="small"
                defaultValue={(content as CalendarContentProps)?.sender_location}
                value={senderLocation}
                onChange={(e) => setSenderLocation(e.target.value)}
                MenuProps={{
                  sx: {
                    maxHeight: '400px',
                  }
                }}
                displayEmpty
                placeholder="Pickup Location"
              >
                {!isLoadingLocation && locations.length === 0 && (
                  <MenuItem disabled value="">No Location Available</MenuItem>
                )}
                {locations.map((option, index) => (
                  <MenuItem key={index} value={option.location_name}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span>{option.location_name}</span>
                      <span className="text-xs" style={{ color: COLOR.gray[400] }}>{option.map[0].building}</span>
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        )}
        {!!taskType && !isCleaningJob && (
          <div>
            <Typography
              fontSize={12}
              color={COLOR.gray[400]}
            >
              {isShowPickup ? 'Delivery Location' : 'Location'}
            </Typography>
            <div style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Select
                sx={{
                  width: '100%'
                }}
                size="small"
                defaultValue={(content as CalendarContentProps)?.recipient_location}
                value={recipientLocation}
                onChange={(e) => setRecipientLocation(e.target.value)}
                MenuProps={{
                  sx: {
                    maxHeight: '400px',
                  }
                }}
              >
                {!isLoadingLocation && locations.length === 0 && (
                  <MenuItem disabled value="">No Location Available</MenuItem>
                )}
                {locations.map((option, index) => (
                  <MenuItem key={index} value={option.location_name}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span>{option.location_name}</span>
                      <span className="text-xs" style={{ color: COLOR.gray[400] }}>{option.map[0].building}</span>
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        )}
        {!!taskType && isCleaningJob && (
          <div>
            <Typography
              fontSize={12}
              color={COLOR.gray[400]}
            >
              Cleaning Mode
            </Typography>
            <div style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Select
                sx={{
                  width: '100%'
                }}
                size="small"
                defaultValue={''}
                value={cleaningType}
                onChange={(e) => setCleaningType(e.target.value)}
                placeholder="Select Cleaning Type"
              >
                {cleaningOptions.map((option, index) => (
                  <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                ))}
              </Select>
            </div>
          </div>
        )}
        {!!taskType && isCleaningJob && (
          <div>
            <Typography
              fontSize={12}
              color={COLOR.gray[400]}
            >
              Zones
            </Typography>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '4px'
            }}>
              <MultiSelection
                label="Zone"
                options={
                  zoneOptions.map((item) => ({
                    label: item.area_name,
                    subLabel: (findMap(item.map) ? "Level " + findMap(item.map)?.map_level?.toString() : ''),
                    value: item.uuid
                  }))
                }
                values={cleaningZones}
                defaultValueNames={(content as ListScheduleCleaningProjection)?.zone?.map((item) => item.zone_name) || []}
                onChangeValues={(newValue) => setCleaningZones(newValue)}
              />

              {zoneErrors.length > 0 && (
                <Stack>
                  {zoneErrors.map((item, idx) => (
                    <Box key={idx}>
                      <Typography sx={{ fontSize: '12px', color: COLOR.accent.danger }}>
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              )}
            </div>
          </div>
        )}
        {!!taskType && (
          <div >
            <Typography
              fontSize={12}
              color={COLOR.gray[400]}
            >
              Start On
            </Typography>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '6px'
            }}>
              <div
                style={{
                  flex: 'auto'
                }}
              >
                <DateTimePicker
                  sx={{
                    '& .MuiInputBase-input': {
                      paddingTop: '8.5px',
                      paddingBottom: '8.5px',
                    },
                    width: '100%'
                  }}
                  minDateTime={!isEdit ? dayjs() : undefined}
                  // defaultValue={content?.timestamp ? dayjs.unix(content?.timestamp) : undefined}
                  value={selectedTime ? dayjs(selectedTime) : undefined}
                  onChange={(date) => setSelectedTime(date?.toDate())}
                />
              </div>
            </div>
          </div>
        )}
        <div>
          <Typography
            fontSize={12}
            color={COLOR.gray[400]}
          >
            Repeat
          </Typography>
          <Select
            sx={{
              width: '100%'
            }}
            size="small"
            value={selectedRepeat}
            onChange={(e) => setSelectedRepeat(e.target.value)}
          >
            {repeatOptions.map((item, index) => (
              <MenuItem key={index} value={item.value}>{item.name}</MenuItem>
            ))}
          </Select>
        </div>
        {selectedRepeat && selectedRepeat !== 'do_not_repeat' && false && (
          <div
            style={{
              display: 'flex',
              flex: 'row',
              alignItems: 'center',
              gap: '4px',
              paddingTop: '6px',
              paddingBottom: '6px',
            }}
          >
            <Typography sx={{ flex: 'none', fontSize: '12px' }}>
              Repeat every
            </Typography>
            <Input defaultValue={1} />
            <Typography sx={{ flex: 'none', fontSize: '12px', mr: '24px' }}>
              {getSelectedRepeatLabel()}
            </Typography>
          </div>
        )}
        {(selectedRepeat === 'weekly' || selectedRepeat === 'biweekly') && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '4px',
              alignItems: 'center',
              marginTop: '4px'
            }}
          >
            {weekdays.map((day, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 'auto',
                  width: '32px',
                  height: '32px',
                  backgroundColor: selectedDays.includes(day) ? COLOR.accent.green : COLOR.gray[200],
                  color: selectedDays.includes(day) ? COLOR.neutral[50] : COLOR.gray[600],
                  borderRadius: '999px',
                  aspectRatio: '1/1',
                  userSelect: 'none',
                  cursor: 'pointer'
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  toggleDay(day)
                }}
              >
                <Typography fontSize={12} sx={{ textTransform: 'capitalize' }}>{day.substring(0, 3)}</Typography>
              </div>
            ))}
          </div>
        )
        }
        {selectedRepeat && selectedRepeat !== 'do_not_repeat' && (

          <div style={{ marginTop: '6px' }}>
            <Typography
              fontSize={12}
              color={COLOR.gray[400]}
            >
              End Repeat
            </Typography>
            <RadioGroup
              value={endRepeatType}
              onChange={(e) => setEndRepeatType(e.target.value)}
            >
              <FormControlLabel style={{ marginTop: '8px', marginRight: '0px', marginLeft: '0px' }} value="none" control={<Radio size="small" />} label={
                <Typography fontSize={14}>None</Typography>
              } />
              <FormControlLabel disabled={disabledEndRepeat} style={{ marginTop: '8px', marginRight: '0px', marginLeft: '0px' }} value="by_occurrence" control={<Radio size="small" />} label={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'center',
                  }}
                >
                  <Typography fontSize={14}>On</Typography>
                  <TextField
                    defaultValue={1}
                    variant="outlined"
                    type="number"
                    size="small"
                    value={parseInt(endByOccurence)}
                    disabled={disabledEndRepeat}
                    onChange={(e) => {
                      setEndRepeatType('by_occurrence')
                      setEndByOccurence(e.target.value.toString())
                    }}
                  />
                  <Typography fontSize={12} color={COLOR.gray[500]}>Occurence(s)</Typography>
                </div>
              } />
              <FormControlLabel disabled={disabledEndRepeat} style={{ marginTop: '8px', marginRight: '0px', marginLeft: '0px' }} value="by_date" control={<Radio size="small" />} label={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '6px',
                    alignItems: 'baseline'
                  }}
                >
                  <Typography fontSize={14}>Before</Typography>
                  <DateTimePicker
                    sx={{
                      '& .MuiInputBase-input': {
                        paddingTop: '8.5px',
                        paddingBottom: '8.5px',
                      },
                      width: '100%',
                      flex: 'auto'
                    }}
                    disabled={disabledEndRepeat}
                    minDate={selectedTime ? dayjs(selectedTime) : undefined}
                    // defaultValue={content?.timestamp ? dayjs(content?.timestamp) : undefined}
                    value={endByDate ? dayjs(endByDate) : undefined}
                    onChange={(e) => {
                      setEndRepeatType('by_date')
                      setEndByDate(e?.toDate())
                    }}
                  />
                </div>
              } />
            </RadioGroup>
          </div>
        )}
        <div style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          gap: '4px',
          marginTop: '8px'
        }}>
          {!!form ? (
            <>
              <Button onClick={() => onCancelEdit?.()} sx={{ width: '100%', flex: 'auto' }} color="info" variant="outlined" disableElevation>
                Cancel
              </Button>
              <Button onClick={() => setOpenConfirmUpdate(true)} sx={{ width: '100%', flex: 'auto' }} variant="outlined" disableElevation>
                Save
              </Button>
            </>
          ) : (
            <>
              <Button onClick={() => onCancelCreate?.()} sx={{ width: '100%', flex: 'auto' }} color="info" variant="outlined" disableElevation>
                Cancel
              </Button>
              <Button
                onClick={(e) => {
                  // e.stopPropagation()
                  onSubmitCreate()
                }}
                disabled={isMutatingScheduledCleaning || isMutatingScheduled}
                sx={{ width: '100%', flex: 'auto' }}
                variant="contained" disableElevation>
                Create
              </Button>
            </>
          )}
        </div>

        <Dialog maxWidth={'lg'} open={openConfirmUpdate} onClose={() => setOpenConfirmUpdate(false)}>
          <DialogTitle fontSize={16} fontWeight={500}>Save Edited Schedule Job</DialogTitle>
          <DialogContent>
            <RadioGroup
              value={editType}
              onChange={(e) => setEditType(e.target.value)}
            >
              <FormControlLabel value="this_event" control={<Radio />} label="This Event" />
              <FormControlLabel value="this_and_following" control={<Radio />} label="This and following events" />
              <FormControlLabel value="all" control={<Radio />} label="All events" />
            </RadioGroup>

            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'end',
              marginTop: '8px',
              gap: '4px'
            }}>
              <Button onClick={() => onCancelConfirmEdit()}>Cancel</Button>
              <Button onClick={() => onSaveConfirmEdit()} variant="contained" disableElevation>Save</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </LocalizationProvider>
  )
}